<template>
    <component
        v-if="statusValidationEmail"
        :is="selectCurrentComponent()"
        :color="color"
    />
</template>

<script>

import VerifyEmailExpiredLink from './VerifyEmailExpiredLink';
import VerifyEmailActivated from './VerifyEmailActivated';
import VerifyEmailLittleMissing from './VerifyEmailLittleMissing';

export default {
    name: 'VerifyEmailIndex',
    components: {
        VerifyEmailExpiredLink,
        VerifyEmailActivated,
        VerifyEmailLittleMissing,
    },
    props: {
        color: {
            type: Object,
            required: true,
        },
        statusValidationEmail: {
            required: true,
        },
    },
    methods: {
        selectCurrentComponent() {
            switch (this.statusValidationEmail) {
            case 'expired':
                return 'VerifyEmailExpiredLink';
            case 'verified':
                return 'VerifyEmailActivated';
            case 'not-verified':
                return 'VerifyEmailLittleMissing';
            default:
                return '';
            }
        },
    },
};
</script>
<style>

</style>
